import { Pipe, PipeTransform } from '@angular/core';

const DEFAULT_TRUNCATE_LIMIT = 40;
const DEFAULT_TRUNCATE_TRAIL = '…';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  public transform(
    value: string,
    limit = DEFAULT_TRUNCATE_LIMIT,
    trailingString = DEFAULT_TRUNCATE_TRAIL,
    countTrailing = false,
  ): string {
    const safeValue = value || '';
    let stringLength = this._getStringLength(limit, trailingString, countTrailing);

    if (stringLength < 0) {
      stringLength *= -1;
      return safeValue.length > stringLength
        ? trailingString + safeValue.substring(safeValue.length - stringLength, safeValue.length)
        : safeValue;
    }

    return safeValue.length > stringLength ? safeValue.substring(0, stringLength) + trailingString : safeValue;
  }

  private _getStringLength(limit: number, trail: string, countTrailing = false): number {
    if (countTrailing) {
      if (limit < 0) {
        return limit + trail.length;
      }

      return limit - trail.length;
    }

    return limit;
  }
}
